import encodeUriObject from './encodeUriObject';

export async function fetchUrlEncoded(
  url: string,
  { body, method = 'POST' }: Request
) {
  const fetchArgs = {
    body: encodeUriObject(body),
    method,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };

  const result = await fetch(url, fetchArgs);

  if (result.status >= 400) {
    throw new Error(
      `Error making request to "${url}". Status code: "${
        result.status
      }". Args: "${JSON.stringify(fetchArgs)}"`
    );
  }

  return result;
}
